export default __webpack_public_path__ + "static/media/Buick.8f13dd20.png";